import { createContext } from 'react';

const LocaleContext = createContext<{
  countryCode: string;
  isTaxRegistered: boolean;
}>({
  countryCode: '',
  isTaxRegistered: false,
});

export default LocaleContext;
